// User store module for managing user name and token
const state = {
  name: localStorage.getItem("user_name") || "",
  role: localStorage.getItem("user_role") || "",
  token: localStorage.getItem("user_token") || "",
  id: localStorage.getItem("user_id") || "",
  company_id: localStorage.getItem("user_company_id") || "",
  mobile_phone: localStorage.getItem("mobile_phone") || "",
  enable_salary_preview:
    localStorage.getItem("enable_salary_preview") === "true" || false,
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  userName: (state) => state.name,
  userRole: (state) => state.role,
  userToken: (state) => state.token,
  userId: (state) => state.id,
  userCompanyId: (state) => state.company_id,
  userMobilePhone: (state) => state.mobile_phone,
  enableSalaryPreview: (state) => state.enable_salary_preview,
  canEditRole: (state) =>
    ["superadmin", "consultant", "hr"].includes(state.role),
  rootRole: (state) => ["superadmin", "consultant"].includes(state.role),
};

const actions = {
  login(
    { commit, dispatch },
    { id, name, token, company_id, role, enable_salary_preview = false }
  ) {
    return new Promise((resolve) => {
      commit("SET_USER_DATA", {
        id,
        name,
        token,
        company_id,
        role,
        enable_salary_preview,
      });
      localStorage.setItem("user_id", id ?? "");
      localStorage.setItem("user_name", name);
      localStorage.setItem("user_token", token);
      localStorage.setItem("user_company_id", company_id);
      localStorage.setItem("user_role", role);
      localStorage.setItem(
        "enable_salary_preview",
        enable_salary_preview ? "true" : "false"
      );

      // Set the selectedCompany in the company store if company_id is provided
      if (company_id) {
        dispatch("company/selectCompany", company_id, { root: true });
      }

      resolve();
    });
  },
  logout({ commit }) {
    return new Promise((resolve) => {
      // Import websocketService here to avoid circular dependency
      const websocketService = require("../../utils/websocketService").default;

      // Disconnect WebSocket if connected
      if (websocketService.isWebSocketConnected()) {
        websocketService.disconnect();
      }

      commit("CLEAR_USER_DATA");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_name");
      localStorage.removeItem("user_token");
      localStorage.removeItem("user_company_id");
      localStorage.removeItem("user_role");
      // localStorage.removeItem('mobile_phone');
      resolve();
    });
  },
  updateUserName({ commit }, name) {
    commit("SET_USER_NAME", name);
    localStorage.setItem("user_name", name);
  },
  updateToken({ commit }, token) {
    commit("SET_USER_TOKEN", token);
    localStorage.setItem("user_token", token);
  },
  updateCompanyId({ commit }, company_id) {
    commit("SET_USER_COMPANY_ID", company_id);
    localStorage.setItem("user_company_id", company_id);
  },
  setMobilePhone({ commit }, mobile_phone) {
    commit("SET_USER_MOBILE_PHONE", mobile_phone);
    localStorage.setItem("mobile_phone", mobile_phone);
  },
};

const mutations = {
  SET_USER_DATA(
    state,
    { id, name, token, company_id, role, enable_salary_preview }
  ) {
    state.id = id ?? "";
    state.name = name;
    state.token = token;
    state.company_id = company_id;
    state.role = role;
    state.enable_salary_preview = !!enable_salary_preview;
  },
  SET_USER_NAME(state, name) {
    state.name = name;
  },
  SET_USER_TOKEN(state, token) {
    state.token = token;
  },
  SET_USER_COMPANY_ID(state, company_id) {
    state.company_id = company_id;
  },
  SET_USER_ID(state, id) {
    state.id = id ?? "";
  },
  SET_USER_MOBILE_PHONE(state, mobile_phone) {
    state.mobile_phone = mobile_phone;
  },
  CLEAR_USER_DATA(state) {
    state.id = "";
    state.name = "";
    state.token = "";
    state.company_id = "";
    state.role = "";
    state.enable_salary_preview = false;
    // state.mobile_phone = '';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
